import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import {
  fetchCurrentUser,
  getCurrentOrganization,
  getOrganizations,
  changeOrganization,
  getCurrentUser,
} from '../../ducks/users'

import { FullScreenLoader } from '../Shared/Loading'

export default function AppLoader({ children }) {
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    dispatch(fetchCurrentUser()).catch(err => {
      if (err.response && err.response.status === 401) {
        history.push('/login')
      }
    })
  }, [dispatch])

  const currentUser = useSelector(getCurrentUser)
  const currentOrg = useSelector(getCurrentOrganization)
  const orgs = useSelector(getOrganizations)

  useEffect(() => {
    const lastOrgId = currentUser && currentUser.lastOrganizationId
    const lastOrg = orgs.filter(o => o.id === lastOrgId)[0]
    const otherOrg = orgs[0]

    if (currentOrg) return

    if (!lastOrg && otherOrg) {
      dispatch(changeOrganization(otherOrg.id))
    }
  }, [dispatch, !!currentOrg, orgs])

  if (!currentOrg) {
    return <FullScreenLoader />
  }

  return children
}
